<div fxLayout="column" fxFlex>
	<h2 mat-dialog-title>Enter Coupon</h2>

	<div fxFlex="100%">
		<div fxLayout="column" fxLayoutAlign="space-evenly stretch" fxLayoutGap="10px" fxFlex="100%">
			<form fxFlex [formGroup]="couponForm" (ngSubmit)="couponForm.valid && onSubmit(couponForm.value)" fxLayout="column" autocomplete="off" autocorrect="off"
			fxLayoutGap="10px" novalidate class="padding-15">
				<mat-form-field>
					<input id="id_coupon_coupon" matInput [placeholder]="'LABEL_COUPON' | translate" formControlName="coupon" minlength="16" maxlength="16" autocomplete="off" required>
					<mat-error *ngIf="couponForm.controls['coupon'].hasError('required')">
						{{ 'MSG_ERROR_COUPON_REQUIRED' | translate }}
					</mat-error>
					<mat-error *ngIf="couponForm.controls['coupon'].hasError('minlength')">
						{{ 'MSG_MINLENGTH' | translate: {length: '16'} }}
					</mat-error> 
				</mat-form-field>

				<mat-label class="mat-warn-color mat-subheading-1" *ngIf="errorMessage">
					{{errorMessage}}
				</mat-label>

				<div fxFlex fxLayout="row" fxLayoutGap="10px" fxLayoutAlign="end">
					<button mat-button [disabled]="isSubmitting" (click)="dialogRef.close(null)" type="button">{{ 'LABEL_CANCEL' | translate }}</button>
					<button color="primary" [class.spinner]="isSubmitting" [disabled]="isSubmitting" mat-raised-button type="submit">{{ (isSubmitting ? 'LABEL_SUBMITTING' : 'LABEL_SUBMIT') | translate }}</button>
				</div>
			</form>
		</div>
	</div>

</div>